export class NotificationCategoriesModel {
    notificationCategoryId:number;
    label : string
    audience:number;
  }